export default {
  name: 'marking--ismpDocumentStatus',
};